import Vue from 'vue'

const initialState = () => ({
  changes: {},
})

export default {
  namespaced: true,
  state: initialState(),
  
  mutations: {
    RESET_STATE (state) {
      Object.assign(state, initialState())
    },
    REGISTER_CHANGE (state, { key, bool }) {
      Vue.set(state.changes, key, bool)
    }
  },

  getters: {
    areChangesUnsaved: state => {
      let result = false

      for (const value of Object.values(state.changes)) {
        if (value) {
          result = true
          break
        }
      }

      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/unsaved-changes.js